import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /** Carousel slides/content to display. Usually a set of `<ProductCarouselSlide />` components */
  children: PropTypes.node.isRequired,
  /** Configuration for the carousel controls */
  controls: PropTypes.shape({
    buttons: PropTypes.arrayOf(PropTypes.shape({
      ariaControls: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      src: PropTypes.string.isRequired,
      alt: PropTypes.string,
      isSelected: PropTypes.bool,
      labelText: PropTypes.string,
      onPointerEnter: PropTypes.func
    })).isRequired,
    onKeyDown: PropTypes.func.isRequired,
    ariaLabel: PropTypes.string,
    labelText: PropTypes.string
  }).isRequired,
  /** Accessible label for the carousel container */
  ariaLabel: PropTypes.string,
  /** Additional CSS classes for the tablist (controls) container */
  classListForTabButtons: PropTypes.string,
  /** Alternative accessible label for the carousel container */
  labelText: PropTypes.string,
  /** Layout direction for the carousel controls and content */
  orientation: PropTypes.oneOf(['horizontal', 'vertical'])
};
function ProductCarousel(_ref) {
  var ariaLabel = _ref.ariaLabel,
    children = _ref.children,
    controls = _ref.controls,
    labelText = _ref.labelText,
    _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? 'horizontal' : _ref$orientation,
    _ref$classListForTabB = _ref.classListForTabButtons,
    classListForTabButtons = _ref$classListForTabB === void 0 ? '' : _ref$classListForTabB;
  return /*#__PURE__*/React__default.createElement("div", {
    "aria-label": ariaLabel || labelText,
    "aria-roledescription": "carousel",
    className: "product-carousel",
    "data-orientation": orientation,
    role: "group"
  }, /*#__PURE__*/React__default.createElement("div", {
    "aria-label": controls.ariaLabel || controls.labelText,
    "aria-orientation": orientation,
    className: "product-carousel-controls ".concat(classListForTabButtons),
    onKeyDown: controls.onKeyDown,
    role: "tablist",
    tabIndex: "-1"
  }, controls.buttons.map(function (_ref2) {
    var alt = _ref2.alt,
      ariaControls = _ref2.ariaControls,
      id = _ref2.id,
      isSelected = _ref2.isSelected,
      buttonLabelText = _ref2.labelText,
      onClick = _ref2.onClick,
      onPointerEnter = _ref2.onPointerEnter,
      ref = _ref2.ref,
      src = _ref2.src;
    return /*#__PURE__*/React__default.createElement("button", {
      "aria-controls": ariaControls,
      "aria-selected": isSelected,
      className: "product-carousel-control-tab",
      id: id,
      key: id,
      onClick: onClick,
      onPointerEnter: onPointerEnter,
      ref: ref,
      role: "tab",
      type: "button",
      tabIndex: !isSelected ? '-1' : null
    }, /*#__PURE__*/React__default.createElement("img", {
      alt: alt || buttonLabelText,
      className: "product-carousel-thumbnail-tab",
      src: src
    }));
  })), children);
}
ProductCarousel.propTypes = propTypes;

export { ProductCarousel as default };
//# sourceMappingURL=ProductCarousel.js.map
